import React from "react";
import { Box, Divider, styled } from "@mui/material";
import IndustrySection from "./industrySection/IndustrySection";
import ReportsSection from "./reportsSection/ReportsSection";
import SearchBar from "../../common/searchBar/SearchBar";

const StyledBox = styled(Box)(({theme}) => ({
  width: '100%',
  display: "flex",
  // flexDirection: 'column',
  alignItems: 'center',
  marginTop: 0,
  marginBottom: 0,
  backgroundColor: 'white',
  padding: theme.spacing(2, 0, 2, 0),
  [theme.breakpoints.down('sm')]: {
    marginTop: '0.5rem',
    marginBottom: '1rem',
  }
}))

const SearchBox = styled(Box)(({theme}) => ({
  width: '35%',
  border: '2px solid #c18dff',
  borderRadius: '5px',
  [theme.breakpoints.down('mdlg')]: {
    width: '65%',
  },
  [theme.breakpoints.down('sm')]: {
    width: '85%',
  }
}))

const ContentBox = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  padding: theme.spacing(2, 0),
  justifyContent: 'space-evenly',
  alignItems: 'start',
  [theme.breakpoints.down('mdlg')]: {
    flexDirection: 'column',
    alignItems: 'center',
  }
}))

function HeroSection() {
  return (
    <StyledBox>
      {/* <Box sx={{ width: '100%', mt: 5, mb: 6, display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
        <SearchBox>
          <SearchBar width='100%' height='3rem' />
        </SearchBox>
      </Box> */}
      <ContentBox>
        <IndustrySection />
        <Divider orientation="vertical" variant="middle" flexItem sx={{ bgcolor: 'grey' }} />
        <ReportsSection/> 
      </ContentBox>
    </StyledBox>
  );
}

export default HeroSection;
